import { render } from "./WpePageTitle.vue?vue&type=template&id=dc80d4fa"
import script from "./WpePageTitle.vue?vue&type=script&lang=js"
export * from "./WpePageTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/templates/WpePageTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc80d4fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc80d4fa', __exports__)) {
    api.reload('dc80d4fa', __exports__)
  }
  
  module.hot.accept("./WpePageTitle.vue?vue&type=template&id=dc80d4fa", () => {
    api.rerender('dc80d4fa', render)
  })

}


export default __exports__